import { render, staticRenderFns } from "./ShipmentCalendar.vue?vue&type=template&id=547a520d&"
import script from "./ShipmentCalendar.vue?vue&type=script&lang=js&"
export * from "./ShipmentCalendar.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentCalendar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports